/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import AssetModel from 'cio/models/asset';

interface AssetLibraryItemImageArgs {
  asset: AssetModel;
  size?: string;
}

export default class AssetLibraryItemImage extends Component<AssetLibraryItemImageArgs> {
  get size() {
    return this.args.size ?? 'xl';
  }

  get assetImage() {
    if (this.args.asset.isDir) {
      return new URL('cio/assets/svgs/folder.svg', import.meta.url).toString();
    }

    return this.args.asset.path;
  }
}
